export default ({ request }) => ({
  systemDict(data = {}, url = '/digitalCenter/common/dict/system') {
    return request({
      url: url,
      method: 'post',
      data
    })
  },
  bizDict(data = {}, url = '/digitalCenter/common/dict/biz') {
    return request({
      url: url,
      method: 'post',
      data
    })
  },
  researchDict() {
    return request({
      url: '/digitalCenter/common/dict/researchDict',
      method: 'post'
    })
  },
  masterCategory(data = {}) {
    return request({
      url: '/digitalCenter/common/dict/masterCategory',
      method: 'post',
      data
    })
  },
  // 省市区县下拉查询接口
  baseRegion(data) {
    return request({
      url: '/digitalCenter/publicMod/select/baseRegion',
      method: 'post',
      data
    })
  },
  // queryProductListApi(data) {
  //   return request({
  //     url: '/digitalCenter/common/dict/queryProductList',
  //     method: 'post',
  //     data
  //   })
  // }
})
